/**
 * Display order for the segment columns.
 *
 * `params.segments` is a transform argument — every route's
 * params_to_transform_args sends it as `segmentation_fields`, and the supply
 * walk sorts by `segmentation_fields + [date_field]`, so its order sets the
 * row sort precedence. Reordering columns therefore must NOT touch it, or
 * every drag would re-run the transform just to re-sort rows.
 *
 * `params.segmentOrder` is display-only. None of the args builders spread
 * params (they are all explicit allowlists), so it never reaches argsJson and
 * never triggers a refetch.
 *
 * The effective order is derived on read rather than kept in sync: entries
 * that are no longer selected drop out, and newly selected segments are
 * appended. That way adding or removing a segment can't leave the two lists
 * disagreeing.
 */
export const getOrderedSegments = (
  segments: string[] | undefined,
  segmentOrder?: string[] | null
): string[] => {
  const selected = segments ?? [];
  if (!segmentOrder || segmentOrder.length === 0) return selected;
  const selectedSet = new Set(selected);
  const ordered = segmentOrder.filter((s) => selectedSet.has(s));
  const placed = new Set(ordered);
  return [...ordered, ...selected.filter((s) => !placed.has(s))];
};
